<template>
  <article class="card person-card">
    <figure class="ratio ratio-11x16">
      <picture v-if="card.imageSlide">
        <v-lazy-image
          class="img-fit"
          :src="card.imageSlide"
          src-placeholder="/public/img/placeholder.gif?mode=crop&width=360&height=640"
          width="360"
          height="640"
          :alt="card.imageAltText"
        >
        </v-lazy-image>
      </picture>
      <picture v-else>
        <img
          class="img-fit"
          src="/public/img/placeholder.gif?mode=crop&width=360&height=640"
          width="360"
          height="640"
          data-src=""
          alt="placeholder image"
        />
      </picture>
      <figcaption class="fs-7 text-uppercase text-shadow text-secondary">
        {{ card.category }}
      </figcaption>
    </figure>
    <h3 class="fs-4 fw-bold text-markpro mt-4 mb-2">
      {{ card.title }}
    </h3>
    <address>
      <a
        v-if="card.phoneNumber && card.phoneNumberTel"
        :href="'tel:' + card.phoneNumberTel"
        >T: {{ card.phoneNumber }}</a
      >
      <br />
      <a v-if="card.email" :href="'mailto:' + card.email"
        >E: {{ card.email }}</a
      >
    </address>
    <div class="rte-text first-paragraph-only" v-html="card.description"></div>
    <div class="mt-1" v-if="card.url">
      <a :href="card.url" class="btn border rounded-pill" @mousedown="preventFocus">Se profil</a>
    </div>
  </article>
</template>

<script>
import VLazyImage from "v-lazy-image";
export default {
  name: "PersonViewCard",
  props: ["card"],
  components: {
    VLazyImage,
  },
  computed: {
    
  },
  methods: {
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>